import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import * as f from "react";
import { createContext as T, useContext as D, isValidElement as M } from "react";
import { f as m } from "./index-LyFokDcn.mjs";
import { b as x, m as j } from "./tss-DN0acMKN.mjs";
import { M as z, d as I } from "./constants-CnFYFetN.mjs";
import { c as $ } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as W } from "./memoTheme-BzXKG_-k.mjs";
import { s as V, b as A, u as E, c as G } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { l as p, L as k, g as H, a as N } from "./ListItemText-C34sqqNp.mjs";
import { B as P } from "./ButtonBase-BIvHZGlt.mjs";
import { u as U } from "./useEnhancedEffect-CJGo-L3B.mjs";
import { u as q } from "./useForkRef-C_4o__cU.mjs";
import { B } from "./body-text-BiQwh5-U.mjs";
const J = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters];
}, K = (e) => {
  const {
    alignItems: t,
    classes: o,
    dense: a,
    disabled: s,
    disableGutters: r,
    divider: i,
    selected: d
  } = e, l = G({
    root: ["root", a && "dense", !r && "gutters", i && "divider", s && "disabled", t === "flex-start" && "alignItemsFlexStart", d && "selected"]
  }, H, o);
  return {
    ...o,
    ...l
  };
}, Q = V(P, {
  shouldForwardProp: (e) => A(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: J
})(W(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${p.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : x(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${p.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : x(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${p.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : x(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : x(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${p.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${p.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), X = /* @__PURE__ */ f.forwardRef(function(t, o) {
  const a = E({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: s = "center",
    autoFocus: r = !1,
    component: i = "div",
    children: d,
    dense: n = !1,
    disableGutters: l = !1,
    divider: g = !1,
    focusVisibleClassName: F,
    selected: R = !1,
    className: h,
    ...u
  } = a, y = f.useContext(k), C = f.useMemo(() => ({
    dense: n || y.dense || !1,
    alignItems: s,
    disableGutters: l
  }), [s, y.dense, n, l]), v = f.useRef(null);
  U(() => {
    r && v.current && v.current.focus();
  }, [r]);
  const S = {
    ...a,
    alignItems: s,
    dense: C.dense,
    disableGutters: l,
    divider: g,
    selected: R
  }, b = K(S), L = q(v, o);
  return /* @__PURE__ */ c.jsx(k.Provider, {
    value: C,
    children: /* @__PURE__ */ c.jsx(Q, {
      ref: L,
      href: u.href || u.to,
      component: (u.href || u.to) && i === "div" ? "button" : i,
      focusVisibleClassName: $(b.focusVisible, F),
      ownerState: S,
      className: $(b.root, h),
      ...u,
      classes: b,
      children: d
    })
  });
}), w = T({
  active: !1,
  disabled: !1,
  muted: !1,
  size: "medium"
}), Y = j()(({ palette: e, typography: t }) => {
  var o, a, s;
  return {
    root: {
      margin: 0
    },
    disabled: {
      color: e.gray[500]
    },
    mediumSize: {
      fontSize: (o = t.medium) == null ? void 0 : o.fontSize,
      lineHeight: "18px"
    },
    primary: {
      alignItems: "center",
      color: e.gray[900],
      display: "flex",
      fontWeight: t.fontWeightRegular
    },
    primaryActive: {
      color: e.common.white,
      fontWeight: t.fontWeightSemibold
    },
    secondary: {
      color: e.gray[700],
      fontSize: (a = t.teenie) == null ? void 0 : a.fontSize,
      lineHeight: "17px",
      marginBottom: 2,
      marginTop: 1
    },
    secondaryActive: {
      color: e.common.white
    },
    smallSize: {
      fontSize: (s = t.small) == null ? void 0 : s.fontSize,
      lineHeight: "17px"
    }
  };
}), O = (e) => {
  const { active: t, disabled: o, muted: a, size: s } = D(w), { classes: r, cx: i } = Y(), { children: d, primary: n, secondary: l } = e, g = n || d;
  return m.ifFeature(
    "encore",
    /* @__PURE__ */ c.jsxs(
      B,
      {
        color: a ? "neutral-weak" : "neutral-extra-strong",
        size: s === "small" || s === "teenie" ? "small" : "medium",
        children: [
          g,
          l && /* @__PURE__ */ c.jsx(B, { color: "neutral-weak", size: "extra-small", children: l })
        ]
      }
    ),
    /* @__PURE__ */ c.jsx(
      N,
      {
        classes: {
          root: r.root,
          primary: i(r.primary, {
            [r.primaryActive]: t && !o,
            [r.mediumSize]: !(s === "small" || s === "teenie"),
            [r.smallSize]: s === "small" || s === "teenie"
          }),
          secondary: i(r.secondary, {
            [r.secondaryActive]: t && !o
          })
        },
        ...e
      }
    )
  );
}, Z = j()(
  ({ constructs: e, palette: t, spacing: o, mode: a }, { alignItems: s = "start" }, r) => ({
    root: {
      alignItems: s,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: m.ifFeature("encore", "row"),
      outline: a === z.Dye ? `1px solid ${I.main}` : void 0,
      padding: m.ifFeature("encore", `10px ${o(2)}`, "5px 10px"),
      textDecoration: "none",
      transition: "none",
      userSelect: "none",
      "&:hover": {
        backgroundColor: "unset"
      },
      [`&.${r.selected}`]: {
        backgroundColor: m.ifFeature("encore", e.surface.neutral.xWeak, t.primary.main),
        "&:hover": {
          backgroundColor: a === z.Dye ? I.lighter : m.ifFeature("encore", e.surface.neutral.xWeak, t.primary.main)
        }
      }
    },
    disabled: {
      backgroundColor: "unset",
      pointerEvents: "none"
    },
    mediumSize: {
      minHeight: 32
    },
    selected: {},
    smallSize: {
      minHeight: 30
    }
  })
), ue = (e) => {
  const { active: t, alignItems: o, children: a, disabled: s, muted: r, size: i, ...d } = e, { classes: n, cx: l } = Z(e);
  return /* @__PURE__ */ c.jsx(w.Provider, { value: { active: t, disabled: s, muted: r, size: i }, children: /* @__PURE__ */ c.jsx(
    X,
    {
      classes: {
        root: n.root,
        disabled: n.disabled,
        selected: n.selected
      },
      className: l({
        [n.mediumSize]: !(i === "small" || i === "teenie"),
        [n.smallSize]: i === "small" || i === "teenie"
      }),
      disabled: s,
      selected: t,
      ...d,
      children: m.ifFeature(
        "encore",
        ["string", "number"].includes(typeof a) ? /* @__PURE__ */ c.jsx(O, { primary: a }) : a,
        M(a) ? a : /* @__PURE__ */ c.jsx(O, { primary: a })
      )
    }
  ) });
};
export {
  w as C,
  ue as M,
  O as T
};
//# sourceMappingURL=menu-item-D2hpbuev.mjs.map
